module.exports = __webpack_public_path__ + "static/media/agametalks.38252c20.jpeg";